import React from 'react'

import DetailedInfoStyled from './styles/item-detailed-info'

const ItemAdvancedInfo = ({ children }) => {
  return <DetailedInfoStyled>{children}</DetailedInfoStyled>
}

export default ItemAdvancedInfo
